import { betDetailApi, IBetDetailApi } from '../api/betDetailApi'
import { IOpBetDetailApi, opBetDetailApi } from '../api/opBetDetailApi'
import { BetDetailTab, DetailGameType } from '../enum/betDetailEnum'
import { initBetDetailData, useBetDetailStore } from '../store/betDetailStore'

export class BetDetailService {
  private betDetailApi: IBetDetailApi
  private opBetDetailApi: IOpBetDetailApi

  constructor(betDetailApi: IBetDetailApi, opBetDetailApi: IOpBetDetailApi) {
    this.betDetailApi = betDetailApi
    this.opBetDetailApi = opBetDetailApi
  }

  public async getBetDetail(refNo: number, statementDate: string) {
    const data = await this.betDetailApi.getBetDetail(refNo, statementDate)
    useBetDetailStore.setState({
      betDetailData: data,
      currentIndex: 0,
      selectShowGameType: BetDetailTab.Normal,
      detailGameType: DetailGameType.Main,
      tableSnapshots: data.gameDetail.snapShots,
    })
  }

  public async getOpBetDetail() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('payload')) {
      const time = urlParams.get('time')
      const data = await this.opBetDetailApi.getOpBetDetail(urlParams.get('payload') as string, time as string)
      useBetDetailStore.setState({
        betDetailData: data,
        currentIndex: 0,
        selectShowGameType: BetDetailTab.Normal,
        detailGameType: DetailGameType.Main,
        tableSnapshots: data.gameDetail.snapShots,
      })
    }
  }

  public resetDetailData() {
    useBetDetailStore.setState({
      isOpenBetDetail: false,
      betDetailData: initBetDetailData,
      currentIndex: 0,
      detailGameType: DetailGameType.Main,
      selectShowGameType: BetDetailTab.Normal,
    })
  }

  public selectNext() {
    const betDetailStore = useBetDetailStore.getState()
    const currentIndex = betDetailStore.currentIndex + 1
    const isFreeGameScene
    = betDetailStore.getfreeSpinFirstPage() !== 0
    && currentIndex >= betDetailStore.getfreeSpinFirstPage()
    if (betDetailStore.computed.hasNext) {
      useBetDetailStore.setState({
        currentIndex: currentIndex,
        detailGameType: isFreeGameScene ? DetailGameType.Free : DetailGameType.Main,
      })
    }
  }

  public selectPrevious() {
    const betDetailStore = useBetDetailStore.getState()
    const currentIndex = betDetailStore.currentIndex - 1
    const isFreeGameScene
    = betDetailStore.getfreeSpinFirstPage() !== 0
    && currentIndex >= betDetailStore.getfreeSpinFirstPage()
    if (betDetailStore.computed.hasPrev) {
      useBetDetailStore.setState({
        currentIndex: currentIndex,
        detailGameType: isFreeGameScene ? DetailGameType.Free : DetailGameType.Main,
      })
    }
  }
}
export const betDetailService = new BetDetailService(betDetailApi, opBetDetailApi)
